import type { ComponentProps } from 'react';
import PlanFlowReview from './PlanFlowReview';
import PlanFlowCardStep from './PlanFlowCardStep';
import PlanFlowCancel from './PlanFlowCancel';

/** Which body the shell is showing. */
export type PlanFlowView = 'review' | 'card' | 'cancel';

/**
 * The body of the flow, picked by view.
 *
 * Each view carries its own child's props, so the modal states what it is
 * showing once and the compiler checks the rest. The modal used to render
 * the review whatever the mode was, which is how "Trocar cartão" opened on
 * the plan selector.
 */
export type PlanFlowBodyProps =
  | { view: 'review'; review: ComponentProps<typeof PlanFlowReview> }
  | { view: 'card'; card: ComponentProps<typeof PlanFlowCardStep> }
  | { view: 'cancel'; cancel: ComponentProps<typeof PlanFlowCancel> };

/**
 * Render the body the current view asks for.
 *
 * @param body - The view and the props of its child.
 * @returns The review, the card step or the cancellation.
 */
export function PlanFlowBody(body: PlanFlowBodyProps) {
  if (body.view === 'card') return <PlanFlowCardStep {...body.card} />;
  if (body.view === 'cancel') return <PlanFlowCancel {...body.cancel} />;
  return <PlanFlowReview {...body.review} />;
}

export default PlanFlowBody;
